module.exports = "<app-snack-service-spinner></app-snack-service-spinner>\n<div class=\"login-background\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/public-background/public-background.component.html
// module id = ./src/app/shared-components/public-background/public-background.component.html
// module chunks = main